module.exports = __webpack_public_path__ + "img/DSC_0074-2.698d568c.jpg";